// --- SaniQ ---
import {DeserializedRecord, deserializeItem, deserializeManyRelationship, Deserializer, JSONAPIManyRelationship, JSONAPIRecord} from "./Helpers";
import {PermissionAccessLevel, PermissionKey} from "vendor/qurasoft/definitions/types/permissions";

interface Permission extends DeserializedRecord {
  type: 'permission';
  key: PermissionKey;
  access: PermissionAccessLevel;
}

interface Role extends DeserializedRecord<'role'> {
  deleteDisabled: boolean;
  editDisabled: boolean;
  label: string;
  /**
   * A role with a name is a system role, that may not be removed or changed
   */
  name?: string;
  autoAssignNewPatient: boolean;
  description?: string;
  permissions: Permission[];
}

interface RoleData extends JSONAPIRecord {
  relationships: {
    permissions: JSONAPIManyRelationship;
  }
}

const deserializeRole: Deserializer<Role, RoleData> = (data, included) => {
  const permissions = deserializeManyRelationship<Permission>(data.relationships.permissions, included);

  return {
    ...deserializeItem(data),
    //NOTE(Keune): System roles (they have a name) may not be changed or deleted
    deleteDisabled: !!data.attributes.name,
    editDisabled: !!data.attributes.name,
    permissions
  };
};

export {
  deserializeRole,
  Permission,
  Role
};
